import { render, staticRenderFns } from "./NotificationNameField.vue?vue&type=template&id=f45aa0b0&scoped=true"
import script from "./NotificationNameField.vue?vue&type=script&lang=js"
export * from "./NotificationNameField.vue?vue&type=script&lang=js"
import style0 from "./NotificationNameField.vue?vue&type=style&index=0&id=f45aa0b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45aa0b0",
  null
  
)

export default component.exports